export const ROLES = {
  ADMIN: 'admin',
  USER: 'user',
  // The platform's own operators. The slug is fixed by the identity service.
  SUPER_ADMIN: 'superadmin',
} as const;

export type Role = typeof ROLES[keyof typeof ROLES]; 

// Role translation keys map
export const ROLE_TRANSLATION_KEYS = {
  [ROLES.ADMIN]: 'ADMIN',
  [ROLES.USER]: 'USER',
  [ROLES.SUPER_ADMIN]: 'SUPER_ADMIN',
} as const;

// Helper function to get translation key for a role
export const getRoleTranslationKey = (role: string): string => {
  return ROLE_TRANSLATION_KEYS[role as Role] || role;
}; 